<fieldset class="enclosure">
  <legend class="enclosure-label">{{ label | i18nextCap }}</legend>
  <div class="items-list">
    @if (value.length > 0) {
      <div class="item-list-inner">
        @for (item of value; track $index) {
          <mat-card class="item">
            <div class="item-names-container">
              <fa-icon
                [icon]="faScrewdriverWrench"
                class="icon blue-icon"
                size="lg"
              ></fa-icon>
              <div class="item-names">
                <span class="main-label">{{ item.part.name }}</span>
                @if (item.part.ref) {
                  <span class="ref">Ref: {{ item.part.ref }}</span>
                }
              </div>
            </div>
            @if (disabled) {
              <span class="item-quantity-container">{{ item.quantity }}</span>
            } @else {
              <mat-form-field class="small item-quantity-container">
                <div class="quantity-input">
                  <button
                    mat-flat-button
                    type="button"
                    [disabled]="item.quantity <= 0"
                    (click)="onAddQuantity(-1, $index)"
                  >
                    -
                  </button>
                  <input
                    matInput
                    type="number"
                    [value]="item.quantity"
                    (change)="onSetQuantity($event, $index)"
                  />
                  <button
                    mat-flat-button
                    type="button"
                    (click)="onAddQuantity(1, $index)"
                  >
                    +
                  </button>
                </div>
              </mat-form-field>
              <button mat-icon-button type="button" (click)="onRemove($index)">
                <mat-icon class="icon red-icon">delete</mat-icon>
              </button>
            }
          </mat-card>
        }
      </div>
    }
  </div>
  @if (!disabled) {
    <div class="field-with-plus">
      <mat-form-field>
        <mat-label>{{ 'forms:add' | i18nextCap }}</mat-label>
        <fo-autocompleting-select
          #autocompleteField
          [choices]="filteredChoices$"
          [choiceOptionTemplate]="choiceOptionTemplate"
          [matchPredicate]="matchPredicate"
          [formControl]="addPartControl"
          (onNewOptionCreate)="createOption($event)"
        >
        </fo-autocompleting-select>
        <fo-arrow matSuffix></fo-arrow>
      </mat-form-field>
      @if (canCreate) {
        <fo-plus-button (click)="onClickCreate()"></fo-plus-button>
      }
    </div>
  }
</fieldset>
